import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

// Standard button
import $ from "jquery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Button = (props) => {
    const buttonRef = useRef();

    useEffect(() => {
        clearTooltip();
    }, [props.tooltipTitle]);

    function clearTooltip() {
        if (props.tooltipTitle) {
            $(buttonRef.current).tooltip("dispose");
        }
    };

    function handleClick(event) {
        clearTooltip();//added because application infinite list is redraw on modal display => orphan tooltip
        if (!props.disabled && props.onClick)
            props.onClick(event);
    };

    let marge = (props.icon && props.label) ? "mr-1" : "mr-0";

    let disabledClassName = "";
    if (props.disabled) {//disabled: just apply css, to keep tooltip working on disabled button
        disabledClassName = " disabled ";
    }

    return (
        <button
            ref={buttonRef}
            type={props.type}
            data-toggle={props.toggleName}
            title={props.tooltipTitle}
            data-target={props.targetName}
            className={"btn " + props.className + disabledClassName}
            onClick={handleClick}
            data-tooltip
        >
            {props.icon && !props.spinner &&
                <FontAwesomeIcon
                    className={marge}
                    icon={props.icon}
                    size={props.iconSize}
                />
            }
            {props.spinner && <span className={"spinner-border spinner-border-sm " + marge} role="status" aria-hidden="true"></span>}
            <span>{props.label}</span>
        </button>
    );
}

Button.defaultProps = {
    className: "btn-submit",
    tooltipTitle: "",
    type: "button",
    toggleName: "modal",
    disabled: false,
    spinner: false
}

/* data-toggle="tooltip" à remplacer par data-tooltip => Bouton affiche des tooltip */
/* data-toggle="modal" => Bouton qui ouvre une fenêtre modale */
/* data-toggle="dropdown" => Bouton qui ouvre un menu déroulant */
/* data-toggle="tab" => Bouton qui ouvre des onglets */
/* data-toggle="collapse" => Bouton qui affiche/cache un element (accordeon) */

Button.propTypes = {
    label: PropTypes.string,
    icon: PropTypes.object,
    disabled: PropTypes.bool,
    targetName: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    spinner: PropTypes.bool,
    tooltipTitle: PropTypes.string,
    type: PropTypes.string
};

export default Button;